<template>
  <div class="custom-grid">
    <el-form-item
      :prop="propName"
      label
      :rules="required ? { required: true, message: `请上传${lebal}` } : {}"
    >
      <!-- <el-input
        v-model="form[propName]"
        style="display:none;"
      /> -->
      <el-upload
        ref="upload"
        class="avatar-uploader"
        :action="actionUrl"
        :show-file-list="false"
        :on-success="
          (res, file) => handleImgSuccess(uploadConfig.prefix, res, file)
        "
        :on-error="(err, file) => handleImgError(uploadConfig.prefix, err, file)"
        :before-upload="file => beforeAvatarUpload(uploadConfig.prefix, file)"
        :headers="headers"
        :disabled="imgLoading || disabled"
      >
        <div v-if="propImg" class="upload-preview">
          <img v-if="!isPropPdf" class="avatar" :src="propImg" />
          <img
            v-else
            class="pdf-thumbnail"
            src="@/assets/icon/pdf.png"
            alt=""
          />
          <span class="el-upload-list__item-actions">
            <span
              class="el-upload-list__item-icon"
              @click.stop="handlePictureCardPreview(uploadConfig.prefix)"
            >
              <i class="el-icon-zoom-in" />
            </span>
            <span
              :hidden="parentData.isDetail || disabled"
              class="el-upload-list__item-icon"
              @click.stop="handleRemove(uploadConfig.prefix)"
            >
              <i class="el-icon-delete" />
            </span>
          </span>
        </div>
        <div v-else class="avatar-uploader-icon">
          <i v-if="imgLoading" class="el-icon-loading" />
          <i v-else class="el-icon-plus" />
        </div>
        <!-- 透明点击层：整个上传区域都可触发选择文件，不再只响应中间的 + -->
        <div
          v-if="!propImg"
          class="upload-hit-area"
          @click.stop="openFilePicker"
        />
      </el-upload>
      <!-- <el-dialog
        :visible.sync="dialogVisible"
        append-to-body
        :modal="showShade"
      >
        <img
          width="100%"
          :src="dialogImageUrl"
          alt
        >
      </el-dialog> -->
      <el-dialog
        title="文件预览"
        :visible.sync="webviewDialogVisible"
        width="60%"
        append-to-body
        :close-on-click-modal="true"
      >
        <iframe
          v-if="webviewDialogVisible"
          :src="webviewUrl"
          frameborder="0"
          style="width: 100%; height: 600px;"
        />
      </el-dialog>
      <el-image-viewer
        v-show="dialogVisible"
        :initial-index="dialogIndex"
        :on-close="
          () => {
            dialogVisible = false;
          }
        "
        :url-list="[dialogImageUrl]"
        style="z-index: 9999"
      />
    </el-form-item>
    <div style="margin-top: 8px;text-align:center">
      <em v-if="required" class="color-red">* </em>{{ lebal }}
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import md5 from "js-md5";
import { getToken } from "@/utils/auth";
export default {
  name: "ImgUpload",
  components: {
    "el-image-viewer": () =>
      import("element-ui/packages/image/src/image-viewer")
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          isDetail: false
        };
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isicon: {
      type: Boolean,
      default: false
    },
    required: {
      type: [Boolean, Number],
      default: true
    },
    uploadConfig: {
      type: Object,
      default() {
        return {
          lebal: "公司logo",
          prefix: "logo",
          suffix: "Img",
          form: {},
          modal: true
        };
      }
    }
  },
  data() {
    return {
      uploadUrl: `${this.BASE_API_URL}ntocc-tps-api/fileUpload`,
      noTokenUploadUrl: `${this.BASE_API_URL}ntocc-tps-api/fileUpload/public`,
      actionUrl: `${this.BASE_API_URL}ntocc-tps-api/fileUpload`,
      dialogImageUrl: "",
      dialogVisible: false,
      webviewDialogVisible: false,
      webviewUrl: "",
      dialogIndex: 0,
      headers: {
        Authorization: "Bearer ",
        deviceId: "0000000000"
      }
    };
  },
  computed: {
    lebal() {
      return this.uploadConfig.lebal;
    },
    imgLoading() {
      return this.uploadConfig.form[
        `${this.uploadConfig.prefix}${this.uploadConfig.suffix}Loading`
      ];
    },
    propImg() {
      return this.uploadConfig.form[
        `${this.uploadConfig.prefix}${this.uploadConfig.suffix}`
      ];
    },
    isPropPdf() {
      return this.isPdfUrl(this.propImg);
    },
    propName() {
      return `${this.uploadConfig.prefix}${this.uploadConfig.suffix}`;
    },
    showShade() {
      return this.uploadConfig.modal;
    },
    form() {
      return this.uploadConfig.form;
    }
  },
  methods: {
    // 透明点击层：直接触发 el-upload 内部的 file input，保证整块区域可点
    openFilePicker() {
      if (this.imgLoading || this.disabled) {
        return;
      }
      const upload = this.$refs.upload;
      const input = upload && upload.$el ? upload.$el.querySelector("input[type=file]") : null;
      if (input) {
        input.click();
      }
    },
    isPdfUrl(url) {
      return typeof url === "string" && url.toLowerCase().endsWith(".pdf");
    },
    // yyyyMMddHHmmss
    formatTimestamp(date = new Date()) {
      const pad = n => String(n).padStart(2, "0");
      return (
        date.getFullYear() +
        pad(date.getMonth() + 1) +
        pad(date.getDate()) +
        pad(date.getHours()) +
        pad(date.getMinutes()) +
        pad(date.getSeconds())
      );
    },
    // 上传前
    beforeAvatarUpload(prefix, file) {
      const isImage =
        file.type === "image/jpeg" ||
        file.type === "image/bmp" ||
        file.type === "image/png" ||
        file.type === "image/gif" ||
        (this.isicon &&
          (file.type === "image/x-icon" || file.type === "image/svg+xml"));
      const isPdf = file.type === "application/pdf";
      const isAllowed = isImage || isPdf;
      const isLtnM2 = file.size >= 1024;
      const maxSizeMb = isPdf ? 50 : 10;
      const isLtnM = file.size / 1024 / 1024 < maxSizeMb;
      if (!isAllowed) {
        this.$message.error(
          this.isicon
            ? "上传文件只能是 JPG,BMP,PNG,icon,GIF 或 PDF 格式!"
            : "上传文件只能是 JPG,BMP,PNG 或 PDF 格式!"
        );
        return false;
      }
      if (!isLtnM2) {
        this.$message.error("上传文件大小不能小于 1K!");
        return false;
      }
      if (!isLtnM) {
        this.$message.error(`上传文件大小不能超过 ${maxSizeMb}MB!`);
        return false;
      }
      if (isAllowed && isLtnM && isLtnM2) {
        this.$set(
          this.uploadConfig.form,
          `${prefix}${this.uploadConfig.suffix}`,
          ""
        );
        this.$set(
          this.uploadConfig.form,
          `${prefix}${this.uploadConfig.suffix}Loading`,
          true
        );
        // 按 Cookie 中 Admin-Token 是否有值切换上传接口与请求头
        const adminToken = Cookies.get("Admin-Token");
        if (adminToken) {
          this.actionUrl = this.uploadUrl;
          this.headers = {
            Authorization: "Bearer " + getToken(),
            deviceId: "0000000000"
          };
        } else {
          const timestamp = this.formatTimestamp();
          const nonce = `${Date.now()}${Math.random()
            .toString(36)
            .slice(2, 10)}`;
          this.actionUrl = this.noTokenUploadUrl;
          this.headers = {
            deviceId: "0000000000",
            timestamp,
            nonce,
            sign: md5(timestamp + nonce)
          };
        }
        // el-upload 同步 return true 时会立刻读旧的 action/headers，需等下一帧再发请求
        return new Promise(resolve => {
          this.$nextTick(() => resolve(true));
        });
      }
      return false;
    },
    // 上传后
    async handleImgSuccess(prefix, res, file) {
      if (res.status == 500) {
        this.$message.error(res.msg);
        this.$set(
          this.uploadConfig.form,
          `${prefix}${this.uploadConfig.suffix}Loading`,
          false
        );
        return;
      } else {
        let url = res.data;
        if (typeof url === "string") {
          url = url.replace(/^http:\/\//, "https://");
        }
        await this.$emit("handleImgSuccess", url);
        this.$set(
          this.uploadConfig.form,
          `${prefix}${this.uploadConfig.suffix}`,
          url
        );
        this.$set(
          this.uploadConfig.form,
          `${prefix}${this.uploadConfig.suffix}Loading`,
          false
        );
      }
    },
    handleImgError(prefix, err) {
      this.$set(
        this.uploadConfig.form,
        `${prefix}${this.uploadConfig.suffix}Loading`,
        false
      );
      this.$message.error("文件上传失败，请检查网络或服务后重试");
    },
    // 放大 / 预览
    handlePictureCardPreview(prefix) {
      let url = this.uploadConfig.form[`${prefix}${this.uploadConfig.suffix}`];
      if (typeof url === "string") {
        url = url.replace(/^http:\/\//, "https://");
      }
      if (this.isPdfUrl(url)) {
        this.webviewUrl = url;
        this.webviewDialogVisible = true;
      } else {
        this.dialogImageUrl = url;
        this.dialogVisible = true;
      }
    },
    // 删除
    handleRemove(prefix) {
      this.$set(
        this.uploadConfig.form,
        `${prefix}${this.uploadConfig.suffix}`,
        ""
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.custom-grid {
  display: inline-block;
  font-size: 14px;
  color: #8c939d;
  margin-right: 20px;
  .avatar-uploader {
    position: relative;
    cursor: pointer;
    height: 150px;
    border-radius: 10px;
    overflow: hidden;
    .avatar-uploader-icon {
      font-size: 30px;
      color: #8c939d;
      border-radius: 10px;
      width: 150px;
      height: 150px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px dashed #c0ccda;
      &:hover {
        border-color: #409eff;
      }
    }
    .upload-hit-area {
      position: absolute;
      inset: 0;
      z-index: 1;
      cursor: pointer;
    }
    .upload-preview {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 150px;
      height: 150px;
    }
    .avatar {
      width: 150px;
      height: 150px;
      display: block;
    }
    .pdf-thumbnail {
      width: 76px;
      height: 90px;
    }
    .el-upload-list__item-actions {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      text-align: center;
      color: #fff;
      opacity: 0;
      font-size: 20px;
      background-color: rgba(0, 0, 0, 0.5);
      transition: opacity 0.3s;
      &:hover {
        opacity: 1;
      }
      .el-upload-list__item-icon {
        cursor: pointer;
        margin: 0 10px;
      }
    }
  }
}
.color-red {
  color: #f44336;
  line-height: 30px;
}
</style>
